<div class="container mt-4">
    <div class="row py-3 border-bottom border-4 border-light">
        <div class="col-sm-12 col-lg-3 px-4">
            <h1 class="h1">HI {{ user.firstName }},</h1>
            <div class="body-title pb-2">Welcome to the Alabama Certification for Educators.</div>
            <div>Your portal for obtaining, managing, and renewing certificates.</div>
        </div>
        <div class="col-sm-12 col-lg-5 px-4 d-none d-lg-block border-start border-end border-4 border-light">
           <app-dashboard-messages></app-dashboard-messages>
        </div>
        <div class="col-sm-12 col-lg-4 px-4 d-none d-lg-block">
            <app-background-review [bgrData]="bgrData"></app-background-review>
        </div>
    </div>

    <div class="row py-3">
        <div class="col-12 col-sm-12 col-lg-6 border-end border-4 border-light">
            <div class="d-flex flex-sm-row flex-column justify-content-between">
                <h1 class="h1">YOUR APPLICATIONS</h1>
                <button class="color-button-primary" mat-flat-button aria-label="New Application" (click)="certWizService.certWizardRedirect()">
                    New Application
                </button>
            </div>
            
            <div class="row applist">
                <div class="col-12">
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" preserveContent>
                        <mat-tab label="Active({{appList.active.length}})">
                            <ng-template matTabContent>
                                <app-application-list [appList]="appList.active" [applistType]="UI_APPLIST_TYPE.appactive" class="py-2 d-block" style="max-height: 500px;"></app-application-list>
                            </ng-template>
                        </mat-tab>
                        <mat-tab label="History({{appList.history.length}})">
                            <ng-template matTabContent>
                                <app-application-list [appList]="appList.history" [applistType]="UI_APPLIST_TYPE.apphistory" class="py-2 d-block" style="max-height: 500px;"></app-application-list>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-lg-6 ">
            <app-current-certs></app-current-certs>
        </div>
    </div>
</div>

<!-- <div class="container-fluid px-4 max-w-100 d-none">
    <div class="row">
        <div class="col-12 col-sm-12 col-lg-9 row reverse pr-0">
            <div class="col-12 col-sm-12 col-lg-4 py-4 pr-0">
                <app-background-review [bgrData]="bgrData"></app-background-review>
                <br />
                <app-dashboard [appList]="appList"></app-dashboard>
            </div>
            <div class="col-12 col-sm-12 col-lg-8 py-4 primary pr-0">
                <h2>Welcome to the Alabama Certification for Educators</h2>
                <h3>This portal provides a central location for educators to obtain, manage, and renew certificates.
                </h3>

                <div class="horz-div"></div>
                <div class="d-flex justify-content-center">
                    <mat-icon color="accent" style="font-size: 32px; margin-top: 12px;"
                        title="New Application">new_releases</mat-icon>
                    <button mat-stroked-button color="accent" aria-label="New Application" class=""
                        style="margin:10px; font-size: 16px;" (click)="newApp()">New Application
                    </button>
                </div>

                <p class="info">Please note the following that applies to all new applications:<br /><br />
                    An application is not considered complete until all supplemental documents have been received and
                    all the requirements for application have been met, including the receipt of an Alabama Law
                    Enforcement Agency (ALEA) and Federal Bureau of Investigation (FBI) criminal history background
                    check completed through this agency. Applications with missing supplemental documents or other
                    requirements will not be assigned to a certification specialist for a review of eligibility for an
                    Alabama license, certificate, or permit.
                </p>
                <br /><br />
                <p class="info">All communication relating to applications submitted via this portal will be through the
                    Email Address on file in AIM. Please make sure your email address is up to date and double check
                    your spam folder for
                    communications.
                </p>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-lg-3 py-4">
            <app-current-certs></app-current-certs>
        </div>
    </div>
</div> -->